import React, { useState } from "react";
import publicApi, { formatError } from "../../api/public";
import SiteLayout from "../../components/site/SiteLayout";
import { Send, Check, Phone, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import SEOHead from "../../components/site/SEOHead";
import { PhoneInput } from "../../components/PhoneInput";
import { CONTACT_PHONE, telLink } from "../../config/contact";

export default function SiteContact() {
  const [form, setForm] = useState({ nom: "", prenom: "", telephone: "", email: "", message: "", type: "contact" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await publicApi.post("/contact", form);
      setDone(true);
      toast.success("Message envoyé !");
      setForm({ nom: "", prenom: "", telephone: "", email: "", message: "", type: "contact" });
    } catch (err) {
      toast.error(formatError(err, "Erreur"));
    } finally { setSending(false); }
  };

  return (
    <SiteLayout>
      <SEOHead title="Contact" description="Contactez TPCO Sénégal — Construction, immobilier et gestion locative à Dakar. Hann Maristes 1, lot F/06/A · contact@tpco.sn · Devis sous 24h." />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#E91E63] font-bold mb-3">Contact</div>
            <h1 className="font-display text-4xl lg:text-6xl font-bold leading-[1.05] mb-6">Parlons de votre projet</h1>
            <p className="text-[#4B5775] text-lg leading-relaxed max-w-md mb-8">TPCO Sénégal vous assiste, cerne tous vos besoins et vous propose une étude et un devis personnalisés.</p>
            <ul className="space-y-4 mb-12">
              <li className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[#E91E63] mt-0.5 shrink-0" /><span className="text-[#0F1A3D]">Hann Maristes 1, lot F/06/A, Dakar, Sénégal</span></li>
              <li className="flex items-center gap-3"><Phone className="w-5 h-5 text-[#E91E63]" /><a href={telLink()} className="text-[#0F1A3D] hover:text-[#1E3A8A]">{CONTACT_PHONE}</a></li>
              <li className="flex items-center gap-3"><Mail className="w-5 h-5 text-[#E91E63]" /><a href="mailto:contact@tpco.sn" className="text-[#0F1A3D] hover:text-[#1E3A8A]">contact@tpco.sn</a></li>
            </ul>
          </div>
          <div className="rounded-lg border border-[#E2E5F1] bg-white p-8 shadow-sm" data-testid="site-contact-page-form">
            {done ? (
              <div className="text-center py-8">
                <div className="w-14 h-14 mx-auto rounded-full bg-[#E5F0E8] text-[#2D5A3C] flex items-center justify-center mb-4"><Check className="w-7 h-7" /></div>
                <h3 className="font-display text-2xl font-bold mb-2">Merci !</h3>
                <p className="text-sm text-[#4B5775]">Votre demande a bien été reçue. Notre équipe vous recontacte sous 24h.</p>
                <button onClick={() => setDone(false)} className="text-xs text-[#1E3A8A] font-semibold hover:underline mt-4">Envoyer une autre demande</button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-3">
                <h3 className="font-display text-2xl font-bold mb-3">Écrivez-nous</h3>
                <div className="grid grid-cols-2 gap-3">
                  <input required value={form.nom} onChange={(e) => setForm({ ...form, nom: e.target.value })} placeholder="Nom *" className="w-full h-11 px-3 text-sm rounded border border-[#E2E5F1] focus:outline-none focus:border-[#1E3A8A]" />
                  <input value={form.prenom} onChange={(e) => setForm({ ...form, prenom: e.target.value })} placeholder="Prénom" className="w-full h-11 px-3 text-sm rounded border border-[#E2E5F1] focus:outline-none focus:border-[#1E3A8A]" />
                </div>
                <PhoneInput required value={form.telephone} onChange={(v) => setForm({ ...form, telephone: v })} testid="site-contact-telephone" placeholder="77 123 45 67" />
                <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" type="email" className="w-full h-11 px-3 text-sm rounded border border-[#E2E5F1] focus:outline-none focus:border-[#1E3A8A]" />
                <textarea required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Votre message…" rows={5} className="w-full px-3 py-2 text-sm rounded border border-[#E2E5F1] focus:outline-none focus:border-[#1E3A8A] resize-none" />
                <button type="submit" disabled={sending} data-testid="site-contact-page-submit" className="w-full inline-flex items-center justify-center gap-2 h-12 rounded-md bg-[#E91E63] hover:bg-[#D81B60] text-white text-sm font-semibold disabled:opacity-60">
                  <Send className="w-4 h-4" /> {sending ? "Envoi…" : "Envoyer le message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
